import React, {useState} from 'react';
import LVUploadComponent from "../Components/Projekte/LVUploadComponent";
import {Button, Col, Row} from 'react-bootstrap';
import {getOut, getToken} from "../Utils/Common";
import Select from "react-select";
import {getUserInfo, sendEmail} from '../API/user';
import {deleteLV, detectEncoding} from '../API/analysenrequestdata';


let listofProjects = await fetch(process.env.REACT_APP_BACKEND_API_URI + "mobileappbackend/readprojects", {
    method: 'POST', headers: {
        'Content-type': 'application/json',
    }, body: JSON.stringify({"token": getToken(), "data": {"organisationID": sessionStorage.getItem("org")}}),
})
    .then((response) => response.json())
    .catch((error) => {
        console.error('Error:', error);
    })

let options = []

if (listofProjects.message === `${process.env.REACT_APP_BACKEND_INVALIDTOKEN}`) {
    getOut(`${process.env.REACT_APP_BACKEND_INVALIDTOKEN}`);
} else {
    options = listofProjects.data.map(a => ({"label": a.projectName, "value": a.projectID}));

}

const MaterialPage = () => {

    const [appProjectID, setAppProjectID] = useState("")
    const [appProjectName, setAppProjectName] = useState("")
    const [S3URL, setS3URL] = useState("")
    const [overwrite, setOverwrite] = useState(false)

    async function parseLV(projectID, S3URL) {
        let body ={}
        let encoding = await detectEncoding(S3URL)
        if(!overwrite){
            body = JSON.stringify({"token": getToken(), "uploadlv_id": projectID, "s3uploadURL": S3URL,
            "app_lv_merge":overwrite,encoding:encoding.encoding})
        }else {
            body = JSON.stringify({"token": getToken(), "uploadlv_id": projectID, "s3uploadURL": S3URL,encoding:encoding.encoding})
        }
        let platformResponse = await fetch(`${process.env.REACT_APP_BACKEND_API_URI}parser/parseunknown`, {
            method: "POST", headers: {
                "Content-Type": "application/json"
            }, body: body
        }).then(data => data.json())
        return platformResponse

    }

    const processFile = () => {
        //parseLV(sessionStorage.getItem("projectID"), sessionStorage.getItem("S3URL"))
        parseLV(appProjectID, S3URL)

            .then(async response => {

                if (response.message === "success" || response.message === "parsing started") {
                    setAppProjectID("")
                    setAppProjectName("")
                    setS3URL("")
                    setOverwrite(false)
                    alert("Material ist erfolgreich bereitgestellt.")

                } else {

                    let userData = await getUserInfo();

                    deleteLV({uid: appProjectID, s3url: S3URL});
                    //deleteLV({ uid: sessionStorage.getItem("projectID"), s3url: sessionStorage.getItem("S3URL") });


                    const emailDetails = {
                        emailtype: "lv_parse_failure",
                        emaildetails: {
                            email: userData.em,
                            username: userData.fn,
                            //projectname: sessionStorage.get("projectName")
                            projectname: appProjectName
                        }
                    };
                    sendEmail(emailDetails);
                    alert("Das LV wurde im falschen Dateiformat hochgeladen.\nDie Analyse kann basierend auf dem GAEB-Format 83 durchgeführt werden.");
                }
                window.location.reload()
            })

    };

    return (

        <div className="handwai-dark"
             style={{
                 height: '94vh', width: '100vw', overflowY: 'scroll', overflowX: 'hidden',
             }}>
            <br/> <br/>
            <Row>
                <Col sm={1}/>
                <Col>
                    <span className="handwai-text-label-normal">{"Projekt wählen:"}</span>
                    <Select options={options} placeholder="Wählen"
                            onChange={async (e) => {
                                setAppProjectID(e.value)
                                setAppProjectName(e.label)
                                console.log(appProjectName, appProjectID, 22)
                                //sessionStorage.setItem("projectID", e.value);
                                //sessionStorage.setItem("projectName", e.label);
                            }
                            }
                    />;
                </Col>
                <Col/>
            </Row>
            <br/> <br/>
            <LVUploadComponent S3URL={S3URL}
                               setS3URL={setS3URL}
                               appProjectID={appProjectID}
                               appProjectName={appProjectName}
            />
            <br/> <br/>
            <Row>
                <Col sm={1}/>
                <Col sm={8}>

                    <input
                        checked={overwrite}
                        onChange={async(e)=>{
                            setOverwrite(e.target.checked)
                        }}
                        type="checkbox"
                        defaultChecked={true}
                        className={"userdetailscheckbox"}
                    />&nbsp
                        <span className="handwai-text-label-normal">{"Existierendes LV-Daten überschrieben"}</span>

                </Col>
            </Row>
            <br/>
            <Row>
                <Col sm={1}/>
                <Col sm={8}>
                    <Button className="handwai-btn-create"
                            onClick={processFile}
                    >Bereitstellen</Button>
                </Col>
                <Col sm={3}/>
            </Row>
        </div>);
};

export default MaterialPage;